var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14 14H10M7 14H5M1.01105 7C1 7.57703 1 8.23647 1 9C1 11.8003 1 13.2004 1.54497 14.27C2.02433 15.2108 2.78924 15.9757 3.73005 16.455C4.79961 17 6.19974 17 9 17H13C15.8003 17 17.2004 17 18.27 16.455C19.2108 15.9757 19.9757 15.2108 20.455 14.27C21 13.2004 21 11.8003 21 9C21 8.23647 21 7.57703 20.989 7M1.01105 7C1.04052 5.46078 1.14859 4.50797 1.54497 3.73005C2.02433 2.78924 2.78924 2.02433 3.73005 1.54497C4.79961 1 6.19974 1 9 1H13C15.8003 1 17.2004 1 18.27 1.54497C19.2108 2.02433 19.9757 2.78924 20.455 3.73005C20.8514 4.50797 20.9595 5.46078 20.989 7M1.01105 7H20.989",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardIcon);
export default __webpack_public_path__ + "static/media/payment-card-icon.b703503e.svg";
export { ForwardRef as ReactComponent };